import { createSelector } from 'reselect';
import { AuditState } from './reducer';

export const selectSyncLogs = (state: any): AuditState => {
  return state.syncLogs;
};

export const selectNextLogsForSync = createSelector(
  selectSyncLogs,
  state => {
    return state.logs.filter(syncLog => syncLog.meta.needSync);
  },
);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/AuditLog/selectors.ts